<!-- Toast Container - Fixed positioning with highest z-index -->
<div class="fixed top-4 right-4 z-[9999] flex flex-col gap-2 pointer-events-none">
    <div
        *ngFor="let toast of toasterService.toasts(); trackBy: trackByToastId"
        animate.enter="anim-toast-enter"
        animate.leave="anim-toast-leave"
        class="min-w-[320px] max-w-[420px] pointer-events-auto"
    >
        <div [class]="getToastClasses(toast.status)">
            <!-- Status Icon -->
            <div class="flex-shrink-0 mt-0.5">
                <div
                    class="flex h-6 w-6 items-center justify-center rounded-full"
                    [class]="getIconClasses(toast.status)"
                >
                    <!-- Success Icon -->
                    <svg
                        *ngIf="toast.status === 'success' || toast.status === 'copy'"
                        class="h-4 w-4"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                    >
                        <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2"
                            d="M5 13l4 4L19 7"
                        />
                    </svg>

                    <!-- Error Icon -->
                    <svg
                        *ngIf="toast.status === 'error'"
                        class="h-4 w-4"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                    >
                        <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2"
                            d="M6 18L18 6M6 6l12 12"
                        />
                    </svg>

                    <!-- Warning Icon -->
                    <svg
                        *ngIf="toast.status === 'warning'"
                        class="h-4 w-4"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                    >
                        <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2"
                            d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
                        />
                    </svg>

                    <!-- Info Icon -->
                    <svg
                        *ngIf="toast.status === 'info'"
                        class="h-4 w-4"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                    >
                        <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2"
                            d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                        />
                    </svg>
                </div>
            </div>

            <!-- Content -->
            <div class="flex-1 min-w-0">
                <p class="text-sm font-medium leading-5">{{ toast.message }}</p>
            </div>

            <!-- Actions -->
            <div class="flex items-start gap-2 ml-2">
                <!-- Action Button -->
                <button
                    *ngIf="toast.action"
                    (click)="onActionClick(toast)"
                    class="text-xs font-medium px-2 py-1 rounded-md transition-colors duration-200 hover:bg-black/10 dark:hover:bg-white/10"
                >
                    {{ toast.action.label }}
                </button>

                <!-- Close Button -->
                <button
                    *ngIf="toast.closable"
                    (click)="onCloseToast(toast.id)"
                    class="flex h-5 w-5 items-center justify-center rounded-md transition-colors duration-200 hover:bg-black/10 dark:hover:bg-white/10"
                    [attr.aria-label]="'Close notification'"
                >
                    <svg
                        class="h-3 w-3"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                    >
                        <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2"
                            d="M6 18L18 6M6 6l12 12"
                        />
                    </svg>
                </button>
            </div>
        </div>
    </div>
</div>
